import styled from 'styled-components';

export default styled.ul`
  font-size: 14px;
  list-style: none;

  padding: 7px 20px;

  color: var(--error-color);
  background-color: rgba(255, 79, 79, 0.15);
  border: 1px solid var(--error-color);
  border-radius: 5px;

  > li {
    margin: 3px 0;
  }
`;
